export default __webpack_public_path__ + "static/media/Group 4601.a8175fb0.svg";